import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w100 pad15 hoverLgreyBg rad10"
}
const _hoisted_2 = {
  class: "fl fs13",
  style: {"width":"400px"}
}
const _hoisted_3 = { class: "fl mr5" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_6 = {
  class: "fl fs13",
  style: {"width":"120px"}
}
const _hoisted_7 = {
  class: "fl fs13",
  style: {"width":"180px"}
}
const _hoisted_8 = {
  class: "fl fs13",
  style: {"width":"150px"}
}
const _hoisted_9 = {
  class: "fl fs13",
  style: {"width":"280px"}
}
const _hoisted_10 = {
  key: 0,
  class: "fl mr10",
  style: {"width":"100px"}
}
const _hoisted_11 = {
  key: 1,
  class: "fl mr10",
  style: {"width":"100px"}
}
const _hoisted_12 = ["src"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.uf)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.uf.original_filename), 1),
          _createElementVNode("img", {
            src: _ctx.$getAssetImageUrl(`/assets/icons/editPen.png`),
            width: "17",
            height: "17",
            class: "ml5 fl mt2 mr5 pointer",
            style: {},
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.editName && _ctx.editName(...args)))
          }, null, 8, _hoisted_4),
          _hoisted_5
        ]),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.fileSize) + " ", 1),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.createdTime) + " ", 1),
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.statusName) + " ", 1),
        _createElementVNode("div", _hoisted_9, [
          (_ctx.uf.status != `pending`)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", {
                  class: "fw600 fl pointer skyblue underline hoverGrey",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.downloadFile(_ctx.uf)))
                }, "ダウンロード")
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_11, " ")),
          (_ctx.uf.can_delete)
            ? (_openBlock(), _createElementBlock("img", {
                key: 2,
                src: _ctx.$getAssetImageUrl(`/assets/icons/trash.png`),
                width: "18",
                height: "21",
                class: "fl pointer",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.deleteFile(_ctx.uf)))
              }, null, 8, _hoisted_12))
            : _createCommentVNode("", true),
          _createTextVNode("   "),
          _hoisted_13
        ]),
        _hoisted_14
      ]))
    : _createCommentVNode("", true)
}